/**
 * IntelligenceWrapper — V2.N.8
 *
 * Raccorde la mini-admin existante IntelligenceHubAdmin (gestion du
 * bot d'intelligence / contenu IA) au panel admin unifié.
 *
 * IntelligenceHubAdmin attend une prop `adminKey` (pattern legacy).
 * On lui passe la clé stockée en localStorage. En mode JWT (sans
 * admin_key), certaines sous-fonctions de cette page legacy peuvent
 * renvoyer 401 — c'est une limite connue de ce composant historique,
 * à migrer vers adminAuthHeader dans un sprint ultérieur. La page
 * reste néanmoins accessible.
 */

import { IntelligenceHubAdmin } from '../../pages/IntelligenceHubAdmin';
import { StorageService } from '../../services/storage';

export function IntelligenceWrapper() {
  const adminKey = StorageService.get<string>('admin_key', '');
  return <IntelligenceHubAdmin adminKey={adminKey} />;
}
